import type { PdfiumSchema } from "@pdfking/pdfium"

import type { PdfiumTypeMap } from "./Bindings"

// Extract all C types used in PdfiumSchema (params and returns)
type ExtractSchemaTypes<S> =
  S extends Record<string, [readonly string[], string]>
    ? S[keyof S][0][number] | S[keyof S][1]
    : never

type PdfiumCTypes = ExtractSchemaTypes<PdfiumSchema>

// Compile-time check: PdfiumTypeMap must have exactly the types from PdfiumSchema
type _CheckSchemaCovered = PdfiumCTypes extends keyof PdfiumTypeMap
  ? true
  : "ERROR: PdfiumTypeMap is missing keys from PdfiumSchema"
type _CheckNoExtra = keyof PdfiumTypeMap extends PdfiumCTypes
  ? true
  : "ERROR: PdfiumTypeMap has extra keys not in PdfiumSchema"
type _CheckTypeMap = _CheckSchemaCovered extends true
  ? _CheckNoExtra
  : _CheckSchemaCovered

export const _typeMapCheck: _CheckTypeMap = true
